import { MtStudyTeamMember } from "server/models"
import { OrderType } from "client/utils"

export interface StudyTeamMemberProps {
    teamMemberId: number
}

export interface StudyTeamMemberList { [teamMemberId: number]: MtStudyTeamMember }
export interface StudyTeamMemberListByStudy { [studyId: number]: number[] }

export interface StudyTeamMemberFilters {
    search?: string
}

export type StudyTeamMemberValidation = { [key in keyof MtStudyTeamMember]?: string }

export interface StudyTeamMemberState {
    teamMemberList: StudyTeamMemberList
    teamMemberListByStudy: StudyTeamMemberListByStudy
    teamMemberIds: readonly number[]
    teamMemberView: MtStudyTeamMember
    teamMemberEdit: MtStudyTeamMember

    sortColumn: keyof MtStudyTeamMember
    sortOrder: OrderType
    filters: StudyTeamMemberFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const STUDY_TEAM_MEMBER_LIST = "STUDY_TEAM_MEMBER_LIST"
export const STUDY_TEAM_MEMBER_LIST_BY_STUDY = "STUDY_TEAM_MEMBER_LIST_BY_STUDY"
export const STUDY_TEAM_MEMBER_IDS = "STUDY_TEAM_MEMBER_IDS"
export const STUDY_TEAM_MEMBER_VIEW = "STUDY_TEAM_MEMBER_VIEW"
export const STUDY_TEAM_MEMBER_EDIT = "STUDY_TEAM_MEMBER_EDIT"

export const STUDY_TEAM_MEMBER_SORT = "STUDY_TEAM_MEMBER_SORT"
export const STUDY_TEAM_MEMBER_FILTERS = "STUDY_TEAM_MEMBER_FILTERS"

export const STUDY_TEAM_MEMBER_RELOAD_LIST = "STUDY_TEAM_MEMBER_RELOAD_LIST"
export const STUDY_TEAM_MEMBER_RELOAD_EDIT = "STUDY_TEAM_MEMBER_RELOAD_EDIT"
